import React from 'react';

interface Update {
  date: string;
  title: string;
  description: string;
  type: 'feature' | 'launch' | 'beta' | 'maintenance';
}

interface UpdatesFeedProps {
  updates: Update[];
}

const UpdatesFeed: React.FC<UpdatesFeedProps> = ({ updates }) => {
  const getUpdateIcon = (type: string) => {
    switch (type) {
      case 'feature': return '✨';
      case 'launch': return '🚀';
      case 'beta': return '🧪';
      case 'maintenance': return '🔧';
      default: return '📢';
    }
  };

  const getUpdateColor = (type: string) => {
    switch (type) {
      case 'feature': return 'update-feature';
      case 'launch': return 'update-launch';
      case 'beta': return 'update-beta';
      case 'maintenance': return 'update-maintenance';
      default: return '';
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const today = new Date();
    const diffTime = Math.abs(today.getTime() - date.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="updates-feed">
      <h3>Latest Updates</h3>
      <div className="updates-list">
        {updates.map((update, index) => (
          <div key={index} className={`update-item ${getUpdateColor(update.type)}`}>
            <div className="update-icon">{getUpdateIcon(update.type)}</div>
            <div className="update-content">
              <div className="update-header">
                <h4 className="update-title">{update.title}</h4>
                <span className="update-date">{formatDate(update.date)}</span>
              </div>
              <p className="update-description">{update.description}</p>
            </div>
          </div>
        ))}
      </div>
      <a href="#" className="view-all-link">View all updates →</a>
    </div>
  );
};

export default UpdatesFeed;